import { computed, inject, Injectable } from '@angular/core';
import { ExpertManagerEventNotificationRecord } from '@libs/shared/api';
import { injectCoreFeature } from '@sprint-expert-manager/app/core/state/core.service';

@Injectable()
export class ExpertManagerEventNotificationService {
  readonly #core = injectCoreFeature();

  readonly slice$$ = this.#core.eventNotificationSlice$$;
  readonly pageQuery$$ = this.#core.eventNotificationPageQuery$$;
  readonly isLoading$$ = this.#core.eventNotificationIsLoading$$;
  readonly isLoaded$$ = this.#core.eventNotificationIsLoaded$$;
  readonly error$$ = this.#core.eventNotificationErrorMessage$$;
  readonly unreadCount$$ = this.#core.eventNotificationUnreadCount$$;
  readonly showOnlyUnread$$ = computed(
    () => this.pageQuery$$().filter?.read === false
  );

  fetchExpertManagerEventNotificationSlice = () =>
    this.#core.fetchExpertManagerEventNotificationSlice();

  fetchNextExpertManagerEventNotificationSlice = () => {
    if (!this.slice$$() || this.slice$$().last) return;
    this.#core.fetchNextExpertManagerEventNotificationSlice();
  };

  fetchExpertManagerEventNotificationById = (id: string) =>
    this.#core.fetchExpertManagerEventNotificationById(id);

  activateExpertManagerEventNotification = (id: string) =>
    this.#core.activateExpertManagerEventNotification(id);

  inactivateExpertManagerEventNotification = (id: string) =>
    this.#core.inactivateExpertManagerEventNotification(id);

  toggleExpertManagerEventNotification = (
    item: ExpertManagerEventNotificationRecord
  ) => {
    return item.readAt
      ? this.#core.unreadExpertManagerEventNotification(item.id)
      : this.#core.readExpertManagerEventNotification(item.id);
  };

  readExpertManagerEventNotification = (
    item: ExpertManagerEventNotificationRecord
  ) => {
    if (item.readAt) return;
    this.#core.readExpertManagerEventNotification(item.id);
  };

  toggleShowOnlyUnreadExpertManagerEventNotifications(checked: boolean) {
    this.#core.updateExpertManagerEventNotificationPageQuery({
      ...this.pageQuery$$().filter,
      read: checked ? false : undefined,
    });
  }

  readAllExpertManagerEventNotifications() {
    this.#core.readAllExpertManagerEventNotifications(
      this.#core.currentUser$$().id
    );
  }

  fetchExpertMangerEventNotificationUnreadCount() {
    this.#core.fetchExpertMangerEventNotificationUnreadCount();
  }
}

export function injectExpertManagerEventNotificationService() {
  return inject(ExpertManagerEventNotificationService);
}
